// extracted by mini-css-extract-plugin
export default {"link":"privacy_link__jRGwW","modalOverlay":"privacy_modalOverlay__Ab1-p","modalContent":"privacy_modalContent__PT98Q","closeButton":"privacy_closeButton__YTnoB"};